import lang from '../../../locales/index';
import ENUMS from '../../enums';

lang.setActiveLanguage('fa-ir');
const locales = lang.localize;

export default [
  {
    name: locales('menu.dashboard'),
    path: '/dashboard',
    icon: 'fal fa-chart-line',
  },

  {
    name: locales('menu.base.data'),
    path: '#',
    icon: 'fal fa-coffee-togo',
    children: [
      {
        icon: 'fal fa-handshake',
        name: locales('titles.my.cafe.info'),
        path: '/my-cafe-info',
        permission: ENUMS.PERMISSIONS.values.VIEW_MY_CAFE_INFO,
      },
      {
        icon: 'fal fa-bars',
        name: locales('titles.menuCategories'),
        path: '/menu-categories',
        permission: ENUMS.PERMISSIONS.values.VIEW_MENU_CATEGORIES_LIST,
      },
      {
        icon: 'fal fa-cocktail',
        name: locales('titles.menuItems'),
        path: '/menu-items',
        permission: ENUMS.PERMISSIONS.values.VIEW_MENU_ITEMS_LIST,
      },
      {
        icon: 'fal fa-abacus',
        name: locales('titles.additionals'),
        path: '/invoice-additions',
        permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_FACTOR_ADDITIONS_LIST,
      },
      // {
      //   icon: 'fal fa-abacus',
      //   name: locales('titles.deductions'),
      //   path: '/invoice-deductions',
      //   permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_FACTOR_DEDUCTIONS_LIST
      // },
    ],
  },
  {
    name: locales('menu.cafes'),
    path: '#',
    icon: 'fal fa-coffee-togo',
    children: [
      {
        name: locales('titles.cafesManagement'),
        path: '/cafes',
        permission: ENUMS.PERMISSIONS.values.VIEW_CAFES_LIST,
      },
      {
        name: locales('titles.introducedCafes'),
        path: '/introduced-cafes',
        permission: ENUMS.PERMISSIONS.values.VIEW_INTRODUCED_CAFES_LIST,
      },
      {
        name: locales('titles.show.contract.list'),
        path: '/cafes-contract',
        permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_CONTRACTS_LIST,
      },
    ],
  },
  {
    name: locales('menu.users'),
    path: '#',
    icon: 'fal fa-users',
    children: [
      {
        name: locales('titles.usersManagement'),
        path: '/users',
        permission: ENUMS.PERMISSIONS.values.VIEW_USERS_LIST,
      },
      {
        name: locales('titles.usersComments'),
        path: '/comments',
        permission: ENUMS.PERMISSIONS.values.VIEW_USERS_COMMENTS_LIST,
      },
      {
        name: locales('titles.ticketsManagement'),
        path: '/tickets',
        permission: ENUMS.PERMISSIONS.values.VIEW_TICKETS_LIST,
      },
    ],
  },
  {
    name: locales('menu.reserves'),
    path: '#',
    icon: 'fal fa-clipboard-list',
    children: [
      {
        name: locales('titles.reservationRequests'),
        path: '/reservation-requests',
        permission: ENUMS.PERMISSIONS.values.VIEW_RESERVES_LIST,
      },
      {
        name: locales('titles.incomingReservations'),
        path: '/incoming-reservations',
        permission: ENUMS.PERMISSIONS.values.VIEW_RESERVES_LIST,
      },
      {
        name: locales('titles.schematicReservation'),
        path: '/schematic-reservations',
        permission: ENUMS.PERMISSIONS.values.VIEW_RESERVES_SCHEMATIC_LIST,
      },
      {
        name: locales('titles.reservationInvoices'),
        path: '/reservations',
        permission: ENUMS.PERMISSIONS.values.VIEW_RESERVES_LIST,
      },
      {
        name: locales('insert.new.reservation.timing'),
        path: '/reservation-timing',
        permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_SCHEDULES_LIST,
      },
      {
        name: locales('titles.manage.reserve.days.and.hours'),
        path: '/reservation-days-management',
        permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_DATES_LIST,
      },
    ],
  },
  {
    name: locales('menu.discounts'),
    path: '#',
    icon: 'fal fa-tags',
    children: [
      {
        name: locales('titles.cafe.discounts'),
        path: '/cafe-discounts',
        permission: ENUMS.PERMISSIONS.values.VIEW_MY_CAFE_DISCOUNTS_LIST,
      },
      {
        name: locales('titles.cafeDiscountRequestsManagement'),
        path: '/cafe-discounts/requests',
        permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_DISCOUNTS_REQUESTED_LIST,
      },
      {
        name: locales('titles.cafeDiscountRequestsArchive'),
        path: '/cafe-discounts/archive',
        permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_DISCOUNTS_ARCHIVED_LIST,
      },
      {
        name: locales('titles.RseeDiscounts'),
        path: '/rsee-discounts',
        permission: ENUMS.PERMISSIONS.values.VIEW_RSEE_DISCOUNTS_LIST,
      },
      {
        name: locales('titles.discountsManagement'),
        path: '/discount-codes',
        permission: ENUMS.PERMISSIONS.values.VIEW_DISCOUNT_CODES_LIST,
      },
    ],
  },
  {
    name: locales('menu.transactions'),
    path: '#',
    icon: 'fal fa-money-bill-alt',
    children: [
      {
        name: locales('titles.paymentsManagement'),
        path: '/payments/list',
        permission: ENUMS.PERMISSIONS.values.VIEW_ONLINE_PAYMENTS_REPORT,
      },
      {
        name: locales('titles.financial.transactions'),
        path: '/financial-transactions/list',
        permission: ENUMS.PERMISSIONS.values.VIEW_FINANCIAL_TRANSACTIONS_REPORT,
      },
      // {
      //   name: locales('titles.reservesCheckout'),
      //   path: '/reserve/checkout',
      //   permission: ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST,
      // },
      {
        name: locales('titles.checkoutReport'),
        path: '/checkout/report',
        permission:
          ENUMS.PERMISSIONS.values.VIEW_RESERVES_READY_TO_CHECKOUT_LIST,
      },
      {
        name: locales('titles.show.takeaway.cafes.financial.report'),
        path: '/takeaway-cafes-financial-report',
        permission: ENUMS.PERMISSIONS.values.VIEW_TAKEAWAY_FACTORS_LIST,
      },
    ],
  },
  {
    name: locales('menu.events'),
    path: '#',
    icon: 'fal fa-calendar-star',
    children: [
      {
        name: locales('titles.requestedCafeEvents'),
        path: '/cafe-events/requesteds',
        permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_EVENTS_REQUESTED_LIST,
      },
      {
        name: locales('titles.archivedCafeEvents'),
        path: '/cafe-events/archives',
        permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_EVENTS_ARCHIVED_LIST,
      },
      {
        icon: 'far fa-calendar-star',
        name: locales('titles.cafeEvents'),
        path: '/cafe-events',
        permission: ENUMS.PERMISSIONS.values.VIEW_MY_CAFE_EVENTS_LIST,
      },
    ],
  },
  {
    name: locales('menu.reports'),
    path: '#',
    icon: 'fal fa-list-alt',
    children: [
      {
        name: locales('titles.reportsOfFinishedReserves'),
        path: '/reports/completed-reserves',
        permission:
          ENUMS.PERMISSIONS.values
            .VIEW_REPORT_OF_COMPLETED_RESERVES_AND_NO_VISITS,
      },
      {
        name: locales('titles.salesReport'),
        path: '/sales/list',
        permission: ENUMS.PERMISSIONS.values.SALES_REPORT,
      },
      {
        name: locales('titles.checkoutReportArchive'),
        path: '/checkout/archive',
        permission: ENUMS.PERMISSIONS.values.VIEW_CHECKOUTS_WITH_CAFE_LIST,
      },
    ],
  },
  {
    name: locales('menu.tpt'),
    path: '#',
    icon: 'fal fa-cogs',
    children: [
      {
        name: locales('titles.manage.ads'),
        path: '/ads',
        permission: ENUMS.PERMISSIONS.values.VIEW_ADS_LIST,
      },
      {
        name: locales('titles.messages'),
        path: '/messages',
        permission: ENUMS.PERMISSIONS.values.VIEW_MESSAGES_LIST,
      },
      {
        name: locales('titles.systemSettings'),
        path: '/settings/list',
        permission: ENUMS.PERMISSIONS.values.VIEW_SYSTEM_SETTINGS,
      },
      {
        name:  locales('manage.cities.and.regions'),
        path: '/cities-and-regions',
        permission: ENUMS.PERMISSIONS.values.VIEW_CITIES_LIST,
      },
    ],
  },
  {
    name: locales('packages'),
    path: '#',
    icon: 'fal fa-box-heart',
    children: [
      {
        name: locales('packages.management'),
        path: '/packages/management',
        permission: ENUMS.PERMISSIONS.values.VIEW_RSEE_PACKAGES_LIST,
      },
      {name: locales('packages.report'),
      path: '/packages/report',
      permission: ENUMS.PERMISSIONS.values.VIEW_RSEE_PACKAGES_SALES_REPORT,
      },
      {
        name: locales('gift.chairs'),
        path: '/packages/gift-chairs',
        permission: ENUMS.PERMISSIONS.values.VIEW_RECHARGE_CHAIRS_REPORT,
      },
    ]
  },
  // {
  //   name: locales('setting'),
  //   path: '#',
  //   icon: 'fal fa-cog',
  //   children: [
  //     {
  //       name: locales('description.printers'),
  //       path: '/printer',
  //       permission: ENUMS.PERMISSIONS.values.VIEW_PRINTERS_LIST,
  //     },
  //   ]
  // },
];
